import styled from 'styled-components';

// TODO: Remove from here and re-allocate. This does not belong in global
const StyledContentSubcontractorName = styled.div`
  .instruction-sub__label {
    opacity: 0.5;
    font-size: 13px;
    margin-top: 4px;
  }
`;

export { StyledContentSubcontractorName };
